var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-header-navigation"
  }, [_vm.mobile ? _c('v-list', {
    staticClass: "main-header-navigation__mobile"
  }, [_vm._l(_vm.items, function (item) {
    return [item.children && item.children.length ? [_c('v-list-group', {
      key: item.title,
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function () {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)];
        },
        proxy: true
      }], null, true)
    }, _vm._l(item.children, function (child) {
      return _c('v-list-item', {
        key: child.title,
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")]);
    }), 1)] : [_c('v-list-item', {
      key: item.title,
      attrs: {
        "to": item.path
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]];
  })], 2) : _c('v-container', {
    staticClass: "container--sm"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var hover = _ref.hover;
        return [_c('ul', {
          staticClass: "main-header-navigation__pc",
          on: {
            "mouseenter": _vm.onMouseEnter
          }
        }, [_vm._l(_vm.items, function (item) {
          return _c('li', {
            key: item.title
          }, [_c('router-link', {
            attrs: {
              "to": item.path
            }
          }, [_vm._v(_vm._s(item.title))]), item.children && item.children.length ? [_c('v-fade-transition', [_c('v-list', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: hover,
              expression: "hover"
            }],
            ref: "dropdownLists",
            refInFor: true,
            attrs: {
              "color": "transparent"
            }
          }, _vm._l(item.children, function (child) {
            return _c('v-list-item', {
              key: child.title,
              attrs: {
                "to": child.path
              }
            }, [_vm._v(" " + _vm._s(child.title) + " ")]);
          }), 1)], 1)] : _vm._e()], 2);
        }), _c('v-fade-transition', [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: hover,
            expression: "hover"
          }],
          staticClass: "navigation-bg",
          style: {
            height: `${_vm.maxDropdownHeight}px`
          }
        })])], 2)];
      }
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }